<template>
	<layout v-if="isTokenValid" class="revery-page">
		<form class="login-box">
			<div class="logo-container">
				<img class="h-100 w-100" src="../../assets/logo-nikan.png" />
			</div>
			<div class="main-row justify-content-between h-100">
				<div class="submit order-first mx-auto login" id="login">
					<div class="title">
						<h2 class="card-title">{{ $t('login.f.main-title') }}</h2>
					</div>
					<div class="field error">
						<div class="error-msg" v-if="message">{{ message }}</div>
					</div>

					<div class="field password position-relative">
						<div class="position-relative mb-2">
							<nk-input id="id_password" @input="validatePassowrd" :options="inputOptions('password', 'password')" autofocus v-model="password"></nk-input>
							<icon class="placeholder-icon" name="lock" group="light" />
							<i @click="showPassword" id="togglePassword" class="id_password placeholder-icon fal fa-eye eye"></i>
						</div>
						<div id="moreThan8Char" class="d-flex hint-text">
							<p class="px-1">
								{{ $t('install.m.PasswordTooShort') }}
							</p>
						</div>
						<div id="useSymbol" class="d-flex hint-text symbol">
							<p class="px-1">
								{{ $t('install.m.useSymbol') }}
							</p>
						</div>
						<div id="useUpperCase" class="d-flex hint-text">
							<p class="px-1">
								{{ $t('install.m.useUpperCase') }}
							</p>
						</div>
					</div>

					<div class="field password position-relative">
						<div class="position-relative mb-2">
							<nk-input id="id_password" @input="validatePassowrd" :options="inputOptions('password', 'confirm-password')" autofocus v-model="confirmPassword"></nk-input>
							<icon class="placeholder-icon" name="lock" group="light" />
						</div>
						<div id="confirmPassword" class="d-flex mt-1 hint-text">
							<p class="px-1">
								{{ $t('install.m.confirmPassword') }}
							</p>
						</div>
					</div>
					<div v-if="isCaptchaEnabled" class="recaptcha">
						<nk-recaptcha v-model="recaptchaToken"></nk-recaptcha>
					</div>
					<div class="buttons">
						<button @click="recover" v-if="!spinning" type="submit">{{ $t('login.buttons.recovery') }}
						</button>
						<div v-else class="sk-chase">
							<div class="sk-chase-dot"></div>
							<div class="sk-chase-dot"></div>
							<div class="sk-chase-dot"></div>
							<div class="sk-chase-dot"></div>
						</div>
					</div>
					<div class="other-logins  mt-4">
						<div class="text-center">
							<!-- <a @click="backToLogin" class="text-pr">{{ $t('login.f.back-to-login') }}</a> -->
							<router-link to="/login" class="text-pr">{{ $t('login.f.back-to-login') }}</router-link>
						</div>
						<div v-if="isSignInEnabled" class="google position-relative">
							<g-signin-button :params="googleSignInParams" @success="onSignInSuccess" @error="onSignInError">
								{{ $t('login.f.google-sign-in') }}
							</g-signin-button>
							<i class="fab fa-google"></i>
						</div>
					</div>

				</div>
			</div>
		</form>

	</layout>
	<div class="token-expired" v-else>
		<img src="../../assets/token-expired.svg" :alt="$t('policy.token-expired')">
		<h3>{{ $t('policy.token-expired') }}</h3>
	</div>
</template>

<script>
	import Layout from '~/views/shared/_layout-login'
	import { mapActions, mapGetters } from 'vuex'
	import $ from 'jquery'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import googleSignInButton from '~/components/general/google-signin-button.vue'

	export default {
		modal: {
			helpTag: 'PasswordRecovery'
		},
		components: {
			Layout,
			'g-signin-button': googleSignInButton
		},
		created() {
			if (this.$route.query.token && this.$route.query.email) {
				this.validateToken(this.$route.query.token, this.$route.query.email)
				this.email = this.$route.query.email
				this.token = this.$route.query.token
			}
		},
		data() {
			return {
				isSignInEnabled: import.meta.env.VITE_GSIGNIN_STATUS === 'enabled',
				isCaptchaEnabled: import.meta.env.VITE_CAPTCHA_STATUS === 'enabled',
				password: null,
				confirmPassword: null,
				recaptchaToken: '',
				message: null,
				spinning: false,
				token: null,
				email: null,
				passwordValidations: {
					moreThan8Chars: false,
					useSymbol: false,
					useUpperCase: false,
					matchConfirm: false,
				},
				isTokenValid: false,
				googleSignInParams: {
					clientId: import.meta.env.VITE_GSIGNIN_CLIENT_ID
				}
			}
		},
		computed: {
			...mapGetters('useraccount', ['currentUser']),
		},
		methods: {
			...mapActions('useraccount', ['authenticateUser']),
			inputOptions(inputType, field) {
				return {
					mode: inputType,
					placeholder: this.$t(`login.f.${field}`),
					height: '45px'
				}
			},
			validateToken(token, email) {
				post(Endpoints.getUrl('user.ValidateResetToken'), { Email: email, Token: token }, null, { ignoreCommercialAccess: true, silent: true })
					.then((result) => {
						this.isTokenValid = true
					})
					.catch(err => {
						this.isTokenValid = false
					})
			},
			validatePassowrd() {
				const password = this.password
				if (password && password.length >= 8) {
					this.passwordValidations.moreThan8Chars = true
					$('#moreThan8Char').addClass('valid')
				}
				else {
					this.passwordValidations.moreThan8Chars = false
					$('#moreThan8Char').removeClass('valid')
				}
				if (password && password.length && password.match('.*[A-Z].*')) {
					$('#useUpperCase').addClass('valid')
					this.passwordValidations.useUpperCase = true
				}
				else {
					this.passwordValidations.useUpperCase = false
					$('#useUpperCase').removeClass('valid')
				}
				if (password && password.length && password.match('(?=.*?[#?!@$%^&*-])')) {
					$('#useSymbol').addClass('valid')
					this.passwordValidations.useSymbol = true
				}
				else {
					this.passwordValidations.useSymbol = false
					$('#useSymbol').removeClass('valid')
				}
				if (password === this.confirmPassword) {
					this.passwordValidations.matchConfirm = true
					$('#confirmPassword').addClass('valid')
				}
				else {
					this.passwordValidations.matchConfirm = false
					$('#confirmPassword').removeClass('valid')
				}

				if (Object.values(this.passwordValidations).every(Boolean))
					return true
				else
					return false
			},
			onSignInSuccess(response, event) {
				this.loginByGoogle(`googletoken=${response.wc.id_token}`)
			},
			onSignInError(error) {
				this.$toast(this.$t('login.m.google-login-failed'), { type: 'error' })
			},
			recover(event) {
				event.preventDefault()
				if (!this.validatePassowrd()) return
				if (this.isCaptchaEnabled && !this.recaptchaToken.length) {
					this.message = this.$t('login.m.recaptcha-unfilled')
					return
				}
				this.spinning = true

				post(Endpoints.getUrl('user.ResetPasswordByEmail'), { Email: this.email, Token: this.token, NewPassword: this.password, ConfirmNewPassword: this.confirmPassword, RT: this.recaptchaToken }, null, { silent: true, ignoreCommercialAccess: true })
					.then((result) => {
						setTimeout(() => {
							this.spinning = false
						}, 2000)
						setTimeout(() => {
							this.$router.push({ name: 'login' })
						}, 2000)
					})
					.catch(err => {
						this.$toast(err.message, { type: 'error' })
						setTimeout(() => {
							this.spinning = false
						}, 2000)
					})
			},
			showPassword() {
				const togglePassword = $('#togglePassword')
				const password = $($('#id_password').children()[0])

				const type = password.attr('type') === 'password' ? 'text' : 'password'
				password.attr('type', type)
				togglePassword.toggleClass('fa-eye-slash')
			},
			loginByGoogle(token) {
				this.submit(token, '')
			},
			submit(username, password) {
				this.spinning = true

				const payload = {
					username: username,
					password: password,
				}

				this.authenticateUser(payload)
					.then((result) => {
						this.$router.push({ name: 'home' })
					})
					.catch((error) => {
						console.log(error)
						if (error.response && error.response.data.message)
							this.message = this.$t(`login.m.${error.response.data.message}`)
						else
							this.message = this.$t('login.m.login-failed')

					})
					.finally(() => {
						setTimeout(() => {
							this.spinning = false
						}, 2000)
					})
			}
		},
	}
</script>

<style src="~/styles/login.less" lang="less"></style>